import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

const COLUMNS = [
  { key: "new_lead", label: "New Lead", color: "border-slate-300" },
  { key: "scheduled", label: "Scheduled", color: "border-blue-300" },
  { key: "in_progress", label: "In Progress", color: "border-amber-300" },
  { key: "completed", label: "Completed", color: "border-emerald-300" },
  { key: "invoiced", label: "Invoiced", color: "border-violet-300" },
  { key: "paid", label: "Paid", color: "border-emerald-400" },
];

export default function Jobs() {
  const [jobs, setJobs] = useState([]);

  async function load() {
    const { data } = await api.get("/jobs");
    setJobs(data);
  }
  useEffect(() => { load(); }, []);

  async function move(id, status) {
    await api.patch(`/jobs/${id}`, { status });
    load();
  }

  function jobsBy(status) {
    return jobs.filter((j) => j.status === status);
  }

  return (
    <div className="p-8 lg:p-10" data-testid="jobs-page">
      <header className="mb-8 flex items-end justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">Pipeline</div>
          <h1 className="font-display text-4xl font-semibold tracking-tight">Job Board</h1>
        </div>
        <Link to="/booking/new" data-testid="jobs-new-btn"
          className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-sm px-3 py-2 rounded-md transition-colors">
          + New Job
        </Link>
      </header>

      <div className="kanban-scroll overflow-x-auto pb-4">
        <div className="flex gap-4 min-w-max">
          {COLUMNS.map((col) => (
            <div key={col.key} className="w-72 shrink-0" data-testid={`kanban-col-${col.key}`}>
              <div className={`bg-white border-t-2 ${col.color} border-x border-b border-slate-200 rounded-md`}>
                <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
                  <div className="text-sm font-medium text-slate-900">{col.label}</div>
                  <div className="text-xs text-slate-500">{jobsBy(col.key).length}</div>
                </div>
                <div className="p-2 space-y-2 min-h-[300px]">
                  {jobsBy(col.key).map((j) => (
                    <div key={j.id} data-testid={`job-card-${j.id}`}
                      className="bg-slate-50 border border-slate-200 rounded-md p-3 hover:border-slate-300 transition-colors">
                      <Link to={`/jobs/${j.id}`} className="block">
                        <div className="text-sm font-medium text-slate-900">{j.customer_name}</div>
                        <div className="text-xs text-slate-500 mt-0.5 capitalize">{j.service_type.replace("_", " ")}</div>
                        <div className="text-xs text-slate-500 mt-1">{j.date} · {j.time}</div>
                        {j.employee_name && <div className="text-xs text-blue-700 mt-1">▸ {j.employee_name}</div>}
                        <div className="text-xs font-semibold text-slate-900 mt-2">${Number(j.price).toFixed(2)}</div>
                      </Link>
                      <select
                        data-testid={`job-status-${j.id}`}
                        value={j.status}
                        onChange={(e) => move(j.id, e.target.value)}
                        className="mt-2 w-full text-xs px-2 py-1 border border-slate-300 rounded outline-none focus:border-blue-500"
                      >
                        {COLUMNS.map((c) => <option key={c.key} value={c.key}>{c.label}</option>)}
                      </select>
                    </div>
                  ))}
                  {jobsBy(col.key).length === 0 && (
                    <div className="text-xs text-slate-400 text-center py-6">No jobs</div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
